const $bc6cdcca92938eb2$export$8dd564b3eda388dc = (text)=>{
    const utf8Arr = new TextEncoder().encode(text);
    return [
        ...utf8Arr
    ].map((c)=>c.toString(2).padStart(8, "0")).join("");
};
const $bc6cdcca92938eb2$export$e90fb89750dba83f = (text)=>{
    const numericRegex = new RegExp(/^\d+$/);
    return numericRegex.test(text);
};
const $bc6cdcca92938eb2$export$84e90f298cb9295 = (text)=>{
    const alphaNumericCharactersRegex = new RegExp(/^[a-zA-Z0-9$%*+\-.\/: ]+$/);
    return alphaNumericCharactersRegex.test(text);
};
const $bc6cdcca92938eb2$export$9a948488dd5c6b4d = (text)=>{
    // ISO-8859-1 (Western Europe) character range in Unicode
    const ISO88591Regex = new RegExp(/^[\u0000-\u00FF]+$/);
    return ISO88591Regex.test(text);
};
const $bc6cdcca92938eb2$export$92376b026946860f = (text)=>{
    // Kanji character range in Unicode
    const kanjiRegex = /[\u4E00-\u9FFF]/;
    return kanjiRegex.test(text);
};
const $bc6cdcca92938eb2$export$3ee75cdd10664221 = (text)=>{
    let selectedMode;
    switch(true){
        case $bc6cdcca92938eb2$export$e90fb89750dba83f(text):
            return selectedMode = "0001";
        case $bc6cdcca92938eb2$export$84e90f298cb9295(text):
            return selectedMode = "0010";
        case $bc6cdcca92938eb2$export$9a948488dd5c6b4d(text):
            return selectedMode = "0100";
        case $bc6cdcca92938eb2$export$92376b026946860f(text):
            return selectedMode = "1000";
        default:
            return selectedMode = "0000";
    }
};


console.log((0, $bc6cdcca92938eb2$export$e90fb89750dba83f)("123feda"));
console.log((0, $bc6cdcca92938eb2$export$8dd564b3eda388dc)("random string of text"));


//# sourceMappingURL=index.4aae1588.js.map
